// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Root_Layout__36NIR"};